// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__26Dsj","primary":"styles_primary__2kx-T","secondary":"styles_secondary__1a4FG","muted":"styles_muted__3eiHr","white":"styles_white__35m8r"};